import { put, takeLatest } from 'redux-saga/effects'
import {
  GET_USERDETAILS,
  GET_USERDETAILS_FAILED,
  GET_USERDETAILS_SUCCESSED,
} from '../actions/actionTypes'
import { AuthApiService } from '../services/AuthApiService';

const _authApiService = new AuthApiService()
function* fetchUserDetails() {
  try {
    //let sessionID = yield _authApiService.getSessionId() 
    var response = yield _authApiService.getUserInfo()
    response.refnum = response.preferred_username
    response.displayName = response.name

    if (!response || response.error) {
      yield put({
        type: GET_USERDETAILS_FAILED,
        message: response.error || "An error has occured"
      })
    } else {
        yield put({
          type: GET_USERDETAILS_SUCCESSED,
          data: Object.assign({
          }, response)
        })
    }

  } catch (error) {
    yield put({
      type: GET_USERDETAILS_FAILED,
      message: error.message
    })
  }

}

export function* watchFetchUserDetails() {
  yield takeLatest(GET_USERDETAILS, fetchUserDetails)
}